import BaseModelFactory from '@app/core/service/base-factory';
import { UserModel } from '@app/modules/user/model/user';

export class UserModelFactory extends BaseModelFactory {
  public static readonly USER: string = 'user';

  protected models = {
    [UserModelFactory.USER]: UserModel,
  };
}
